export default __webpack_public_path__ + "static/media/empty_fusindo.d67e6f90.svg";